// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2o9uQ","boxTitle":"Qualiphy_boxTitle__3_FsS","box":"Qualiphy_box__3kWXO","toggleWrap":"Qualiphy_toggleWrap__1NphC"};